
export default {
  name: 'BbCarouselItem',
  props: {
    src: {
      type: [String, Boolean],
      default: '',
    },
  },
};
